<template>
	<div class="cme-options" v-if="Auth.checkPermission( 'VIEW_CME' )">
		<h3 class="ribbon tertiary left">CME Options</h3>
		<p>At {{ Brand.getProperBrand() }} we want to help you stay up-to-date on the latest topics, tools and learnings. Whether you attend one of our live events or view our on-demand webinars, we're here to support your delivery of quality care. Take advantage of the ways you can earn CME credit, and possibly a premium credit, at no cost to you.</p>
		<p>
			<router-link to="/page/cme" tag="button" class="btn btn-primary">Learn More</router-link>
		</p>
		<hr class="dashed">
	</div>
</template>

<script>
import Brand from '@/services/Brand';
import Auth from '@/services/Auth';

export default {
	name: 'CMEOptions',
	data() {
		return {
			Auth,
			Brand
		};
	},
};
</script>
